<ng-container *ngIf="getControl().errors && getControl().errors['incorrect']; else noIncorrect" >
    <div class="invalid-feedback d-block">
        <i class="fas fa-exclamation-triangle" *ngIf="getControl().touched || onlyIcon" title="{{'common.errors.form.incorrect.time' | translate}}{{item ? '.&nbsp;' + item : ''}}"></i>
        <small *ngIf="getControl().touched && !onlyIcon">&nbsp;</small>
        <small *ngIf="!onlyIcon">{{'common.errors.form.incorrect.time' | translate}}{{item ? '.&nbsp;' + item : ''}}</small>
    </div>
</ng-container>
<ng-template #noIncorrect>
    <app-form-error [form]="form" [controlName]="controlName" [format]="format" [required]="required" [interval]="interval" [expired]="expired" [item]="item" [mustBeEmpty]="mustBeEmpty" [onlyIcon]="onlyIcon"></app-form-error>
</ng-template>
